import { initOtelBrowser } from "@pepdirect/v3/helpers/otelBrowser";

// PGS-3499: runs once, before hydration — the right place for a one-time
// tracer provider registration, unlike a component tied to React's mount
// lifecycle. Sentry's own client bootstrap (sentry.client.config.ts) is
// wired separately via @sentry/nextjs's build plugin; this hook is
// independent of it.
initOtelBrowser("pantryshop");
